import React, { useEffect, useState } from "react";
import styles from "./fd.module.css";
import InvestmentDetails from "./InvestmentDetails/InvestmentDetails";
import KnowledgeHub from "./KnowledgeHub/KnowledgeHub";
import DetailGraph from "./DetailedBreakdown/DetailedBreakDown";
import { useNavigate } from "react-router-dom";

const FD = () => {
  const [investmentAmount, setInvestmentAmount] = useState(5000);
  const [expectedReturns, setExpectedReturns] = useState(0);
  const [investmentYears, setInvestmentYears] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.breadCrumb}
        onClick={() => navigate("/calculator")}
      >
        <span class="material-symbols-rounded">chevron_left</span>
        <h1>FD Calculator</h1>
      </div>

      <InvestmentDetails
        setInvestmentAmount={setInvestmentAmount}
        investmentAmount={investmentAmount}
        setExpectedReturns={setExpectedReturns}
        expectedReturns={expectedReturns}
        setInvestmentYears={setInvestmentYears}
        investmentYears={investmentYears}
      />

      <DetailGraph
        investmentAmount={investmentAmount}
        expectedReturns={expectedReturns}
        investmentYears={investmentYears}
      />

      <KnowledgeHub />
    </div>
  );
};

export default FD;
